import React, { useState, useEffect, useRef } from 'react';
import Header from '../../Components/Onboarding-Header/header';
import Sidebar from '../../Components/Onboarding.sidebar/onboarding-sidebar';
import {
  steps,
  stepsCorporate,
  stepsTrust,
  stepsJointAccount,
  stepsBuisness,
  stepsAgency,
  stepsAgent,
} from '../../Constants/config';
import PersonalInfo from './Steps/personal-info';
import BusinessInfo from './Steps/business-info';
import ProofInfo from './Steps/proof-info';
import UploadProof from './Steps/upload-proof';
import ReviewSubmit from './Steps/review-submit';
import CorporateInfo from './Corporate-steps/corporate-info';
import DirectorInfo from './Corporate-steps/directors-info';
import UploadProofCorporate from './Corporate-steps/upload-proof-corporate';
import ReviewSubmitCorporate from './Corporate-steps/review-submit-corporate';
import AgentPersonalInfo from './agent-user-steps/agent-user-info';
import AgentUploadProof from './agent-user-steps/upload-proof-agent';
import AgentReviewSubmit from './agent-user-steps/review-submit-agent';

import TrustInfo from './Trust-steps/trust-info';
import TrusteeInfo from './Trust-steps/trustee-info';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  setCurrentStepRedux,
  setCurrentStepCorprateRedux,
  setCurrentStepTrustRedux,
  setStepStatus,
  setRejectedFields,
  clearStepStatusShareholder,
} from '../../Redux/store/onboardingFormSlice';
import UploadProofTrust from './Trust-steps/upload-proof-trust';
import ReviewSubmitTrust from './Trust-steps/review-submit-trust';
import {
  setApplicationTypeShareHolder,
  clearApplicationTypeShareHolder,
} from '../../Redux/store/accountTypeSlice';
import { useToast } from '../../Utils/toastContext';
import BusinessUserInfo from './buisness-user-steps/business-user-info';
import UploadProofBusiness from './buisness-user-steps/upload-proof-business';
import ReviewSubmitBusiness from './buisness-user-steps/review-submit-business';

const stepMappingSoleTrader = {
  PERSONAL_INFORMATION: 1,
  BUSINESS_INFORMATION: 2,
  PROOF_ITS_YOU: 3,
  UPLOAD_PROOF_DOCS: 4,
  REVIEW_AND_SUBMIT: 5,
};
const stepMappingIndividual = {
  PERSONAL_INFORMATION: 1,
  PROOF_ITS_YOU: 2,
  UPLOAD_PROOF_DOCS: 3,
  REVIEW_AND_SUBMIT: 4,
};

const stepMappingJointAccount = {
  PERSONAL_INFORMATION: 1,
  PROOF_ITS_YOU: 2,
  UPLOAD_PROOF_DOCS: 3,
  REVIEW_AND_SUBMIT: 4,
};
const stepMappingCorporate = {
  CORPORATE_INFORMATION: 1,
  DIRECTORS_SHAREHOLDERS: 2,
  UPLOAD_PROOF_DOCS: 3,
  REVIEW_AND_SUBMIT: 4,
};
const stepMappingTrust = {
  TRUST_INFORMATION: 1,
  TRUSTEES_BENEFICIARIES: 2,
  UPLOAD_PROOF_DOCS: 3,
  REVIEW_AND_SUBMIT: 4,
};
const stepMappingBusiness = {
  AGENCY_INFORMATION: 1,
  AGENCY_COMPLIANCE_DOCS: 2,
  AGENCY_REVIEW_AND_SUBMIT: 3,
};
// Agency uses same mapping
const stepMappingAgency = stepMappingBusiness;

// Optional: Agent mapping if API ever returns AGENT_* sections
const stepMappingAgent = {
  AGENT_INFORMATION: 1,
  AGENT_COMPLIANCE_DOCS: 2,
  AGENT_REVIEW_AND_SUBMIT: 3,
  // fallback for current agent flow (no backend mapping yet)
  PERSONAL_INFORMATION: 1,
  UPLOAD_PROOF_DOCS: 2,
  REVIEW_AND_SUBMIT: 3,
};

const MultiStepSidebarForm = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const dispatch = useDispatch();
  const { showToast } = useToast();

  const navigate = useNavigate();
  const currentStepRedux = useSelector((state) => state.form.currentStep);
  const [currentStep, setCurrentStep] = useState(Number(currentStepRedux) || 1);
  const individualAccountType = useSelector(
    (state) => state.form.individualAccountType,
  );

  const [currentStepJointAccount, setCurrentStepJointAccount] = useState(
    Number(currentStepRedux) || 1,
  );
  const [currentStepBusiness, setCurrentStepBusiness] = useState(
    Number(currentStepRedux) || 1,
  );
  const [currentStepAgent, setCurrentStepAgent] = useState(
    Number(currentStepRedux) || 1,
  );
  const currentStepCorporateRedux = useSelector(
    (state) => state.form.currentStepCorprate,
  );

  const [currentStepCorporate, setCurrentStepCorporate] = useState(
    Number(currentStepCorporateRedux) || 1,
  );
  const currentStepTrustRedux = useSelector(
    (state) => state.form.currentStepTrust,
  );

  const [currentStepTrust, setCurrentStepTrust] = useState(
    Number(currentStepTrustRedux) || 1,
  );
  const isInvitee = useSelector((state) => state.user.isInvitee);
  const roleName = useSelector((state) => state.user.roleName);

  const isBusiness =
    roleName === 'business' || roleName === 'agency' ? true : false;

  const isInviteeDirector = useSelector(
    (state) => state.user.isInviteeDirector,
  );

  const applicationType = useSelector(
    (state) => state.accountType.applicationType,
  );
  const isSoleTrader = individualAccountType === 5;

  // Keep latest onboarding data to recompute when roleName/applicationType loads later
  const [onboardingData, setOnboardingData] = useState(null);
  const onboardingDataRef = useRef(null);

  const individualSteps = isSoleTrader
    ? [
        { id: 1, title: 'Personal Information' },
        { id: 2, title: 'Business Information' },
        { id: 3, title: "Prove It's You" },
        { id: 4, title: 'Upload Proof Doc' },
        { id: 5, title: 'Review & Submit' },
      ]
    : [
        { id: 1, title: 'Personal Information' },
        { id: 2, title: "Prove It's You" },
        { id: 3, title: 'Upload Proof Doc' },
        { id: 4, title: 'Review & Submit' },
      ];

  const renderStepContent = () => {
    dispatch(setCurrentStepRedux(currentStep));

    const stepMap = isSoleTrader
      ? {
          1: <PersonalInfo setCurrentStep={setCurrentStep} />,
          2: <BusinessInfo setCurrentStep={setCurrentStep} />,
          3: <ProofInfo setCurrentStep={setCurrentStep} />,
          4: <UploadProof setCurrentStep={setCurrentStep} />,
          5: <ReviewSubmit setCurrentStep={setCurrentStep} />,
        }
      : {
          1: <PersonalInfo setCurrentStep={setCurrentStep} />,
          2: <ProofInfo setCurrentStep={setCurrentStep} />,
          3: <UploadProof setCurrentStep={setCurrentStep} />,
          4: <ReviewSubmit setCurrentStep={setCurrentStep} />,
        };

    return stepMap[currentStep] || <div>Step not found</div>;
  };
  const renderStepContentAgent = () => {
    dispatch(setCurrentStepRedux(currentStepAgent));
    switch (currentStepAgent) {
      case 1:
        return <AgentPersonalInfo setCurrentStep={setCurrentStepAgent} />;
      case 2:
        return <AgentUploadProof setCurrentStep={setCurrentStepAgent} />;
      case 3:
        return <AgentReviewSubmit setCurrentStep={setCurrentStepAgent} />;
      default:
        return <div>Step not found</div>;
    }
  };
  const renderStepContentJointAccount = () => {
    dispatch(setCurrentStepRedux(currentStepJointAccount));
    switch (currentStepJointAccount) {
      case 1:
        return <PersonalInfo setCurrentStep={setCurrentStepJointAccount} />;
      case 2:
        return <ProofInfo setCurrentStep={setCurrentStepJointAccount} />;
      case 3:
        return <UploadProof setCurrentStep={setCurrentStepJointAccount} />;
      case 4:
        return <ReviewSubmit setCurrentStep={setCurrentStepJointAccount} />;
      default:
        return <div>Step not found</div>;
    }
  };
  const renderStepContentBusiness = () => {
    dispatch(setCurrentStepRedux(currentStepBusiness));
    switch (currentStepBusiness) {
      case 1:
        return <BusinessUserInfo setCurrentStep={setCurrentStepBusiness} />;
      case 2:
        return <UploadProofBusiness setCurrentStep={setCurrentStepBusiness} />;
      case 3:
        return <ReviewSubmitBusiness setCurrentStep={setCurrentStepBusiness} />;
      default:
        return <div>Step not found</div>;
    }
  };
  const renderStepContentCorporate = () => {
    dispatch(setCurrentStepCorprateRedux(currentStepCorporate));
    switch (currentStepCorporate) {
      case 1:
        return <CorporateInfo setCurrentStep={setCurrentStepCorporate} />;
      case 2:
        return <DirectorInfo setCurrentStep={setCurrentStepCorporate} />;
      case 3:
        return (
          <UploadProofCorporate setCurrentStep={setCurrentStepCorporate} />
        );
      case 4:
        return (
          <ReviewSubmitCorporate setCurrentStep={setCurrentStepCorporate} />
        );
      default:
        return <div>Step not found</div>;
    }
  };
  const renderStepContentTrust = () => {
    dispatch(setCurrentStepTrustRedux(currentStepTrust));
    switch (currentStepTrust) {
      case 1:
        return <TrustInfo setCurrentStep={setCurrentStepTrust} />;
      case 2:
        return <TrusteeInfo setCurrentStep={setCurrentStepTrust} />;
      case 3:
        return <UploadProofTrust setCurrentStep={setCurrentStepTrust} />;
      case 4:
        return <ReviewSubmitTrust setCurrentStep={setCurrentStepTrust} />;
      default:
        return <div>Step not found</div>;
    }
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === 'object' && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };

  // Centralized logic to decide step from onboarding data
  const applyOnboardingStatus = (data) => {
    if (!data || data.length === 0) return;

    // Always sort by id to guarantee order
    const sorted = [...data].sort((a, b) => a.id - b.id);

    // Detect business/agency flow from payload itself - more reliable than roleName timing
    const isAgencyFlowFromPayload = sorted.some((s) =>
      s.section?.startsWith('AGENCY_'),
    );
    const isBusinessFlow =
      isAgencyFlowFromPayload ||
      isBusiness ||
      roleName === 'business' ||
      roleName === 'agency';
    const isAgentFlow = roleName === 'agent';

    // Priority: REJECTED > PENDING > DRAFT > otherwise last item (all APPROVED => go to Review)
    let targetSection =
      sorted.find((item) => item.status === 'REJECTED') ||
      sorted.find((item) => item.status === 'PENDING') ||
      sorted.find((item) => item.status === 'DRAFT') ||
      null;

    if (!targetSection) {
      // All APPROVED - fallback to Review & Submit step (last element)
      targetSection = sorted[sorted.length - 1];
    }

    // console.log('Onboarding target:', targetSection, 'isBusinessFlow:', isBusinessFlow);

    // BUSINESS / AGENCY LOGIC - FIXED
    if (isBusinessFlow) {
      if (targetSection && stepMappingBusiness[targetSection.section]) {
        const stepNumber = stepMappingBusiness[targetSection.section];
        setCurrentStepBusiness(stepNumber);
        dispatch(setCurrentStepRedux(stepNumber));
      } else if (targetSection && stepMappingAgency[targetSection.section]) {
        const stepNumber = stepMappingAgency[targetSection.section];
        setCurrentStepBusiness(stepNumber);
        dispatch(setCurrentStepRedux(stepNumber));
      } else {
        // Fallback safety: if mapping missing, infer from status array position
        // Example given: [APPROVED, PENDING, PENDING] => should be step 2
        const firstNonApprovedIndex = sorted.findIndex(
          (s) => s.status !== 'APPROVED',
        );
        if (firstNonApprovedIndex !== -1) {
          const stepNumber = firstNonApprovedIndex + 1; // 1-based
          setCurrentStepBusiness(stepNumber);
          dispatch(setCurrentStepRedux(stepNumber));
        } else {
          // All approved -> review step 3
          setCurrentStepBusiness(3);
          dispatch(setCurrentStepRedux(3));
        }
      }
      return;
    }

    // AGENT LOGIC
    if (isAgentFlow) {
      if (targetSection && stepMappingAgent[targetSection.section]) {
        const stepNumber = stepMappingAgent[targetSection.section];
        setCurrentStepAgent(stepNumber);
        dispatch(setCurrentStepRedux(stepNumber));
      } else {
        // Fallback for agent using same index logic
        const firstNonApprovedIndex = sorted.findIndex(
          (s) => s.status !== 'APPROVED',
        );
        if (firstNonApprovedIndex !== -1) {
          setCurrentStepAgent(firstNonApprovedIndex + 1);
          dispatch(setCurrentStepRedux(firstNonApprovedIndex + 1));
        }
      }
      return;
    }

    // NON-BUSINESS LOGIC (Individual, Corporate, Trust, Joint)
    if (!isInvitee && !isBusinessFlow) {
      // Individual
      if (
        applicationType == 1 ||
        applicationType == 2 ||
        applicationType == 3 ||
        applicationType == 4 ||
        applicationType == 5
      ) {
        const individualStepMapping = isSoleTrader
          ? stepMappingSoleTrader
          : stepMappingIndividual;
        if (targetSection && individualStepMapping[targetSection.section]) {
          const stepNumber = individualStepMapping[targetSection.section];
          setCurrentStep(stepNumber);
          dispatch(setCurrentStepRedux(stepNumber));
        } else if (!targetSection) {
          // fallback to review
          const reviewStep = isSoleTrader ? 5 : 4;
          setCurrentStep(reviewStep);
          dispatch(setCurrentStepRedux(reviewStep));
        }
      }
      // Corporate
      if (
        applicationType == 6 ||
        applicationType == 7 ||
        applicationType == 8
      ) {
        if (targetSection && stepMappingCorporate[targetSection.section]) {
          const stepNumber = stepMappingCorporate[targetSection.section];
          setCurrentStepCorporate(stepNumber);
          dispatch(setCurrentStepCorprateRedux(stepNumber));
        } else if (!targetSection) {
          setCurrentStepCorporate(4);
          dispatch(setCurrentStepCorprateRedux(4));
        }
      }
      // Trust
      if (
        applicationType == 9 ||
        applicationType == 10 ||
        applicationType == 11
      ) {
        if (targetSection && stepMappingTrust[targetSection.section]) {
          const stepNumber = stepMappingTrust[targetSection.section];
          setCurrentStepTrust(stepNumber);
          dispatch(setCurrentStepTrustRedux(stepNumber));
        } else if (!targetSection) {
          setCurrentStepTrust(4);
          dispatch(setCurrentStepTrustRedux(4));
        }
      }
    } else {
      // Joint account / Invitee
      if (targetSection && stepMappingJointAccount[targetSection.section]) {
        const stepNumber = stepMappingJointAccount[targetSection.section];
        setCurrentStepJointAccount(stepNumber);
        dispatch(setCurrentStepRedux(stepNumber));
      }
    }
  };

  const getOnboardingStatus = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/onboarding/status`);
      if (response.status == 200) {
        if (response.data.length > 0) {
          dispatch(setStepStatus(response.data));
          const sorted = [...response.data].sort((a, b) => a.id - b.id);
          setOnboardingData(sorted);
          onboardingDataRef.current = sorted;
          // Apply immediately, and also the useEffect below will re-apply when roleName loads
          applyOnboardingStatus(sorted);
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          showToast(response.message, 'error');
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem('jwtToken');
        navigate('/login');
      }
      showToast(err.message, 'error');
    }
  };

  const getRejectedField = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/onboarding/rejected-fields`);
      if (response.status == 200) {
        dispatch(setRejectedFields(response.data)); // <-- Save in Redux
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          showToast(response.message, 'error');
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem('jwtToken');
        navigate('/login');
      }
      showToast(err.message, 'error');
    }
  };

  useEffect(() => {
    getOnboardingStatus();
    getRejectedField();
    // dispatch(clearApplicationTypeShareHolder());
    // dispatch(clearStepStatusShareholder());
  }, []);

  // Re-apply logic when roleName, applicationType, or individualAccountType becomes available
  // This fixes the bug where initial fetch happens before Redux user slice is hydrated
  useEffect(() => {
    if (onboardingDataRef.current) {
      applyOnboardingStatus(onboardingDataRef.current);
    } else if (onboardingData) {
      applyOnboardingStatus(onboardingData);
    }
  }, [roleName, applicationType, individualAccountType, isInvitee, isBusiness]);

  return (
    <div className=" w-full max-w-full overflow-x-hidden">
      <Header
        setCurrentStep={
          isBusiness
            ? setCurrentStepBusiness
            : Number(applicationType) == 1 ||
                Number(applicationType) == 2 ||
                Number(applicationType) == 3 ||
                Number(applicationType) == 4 ||
                Number(applicationType) == 5
              ? isInvitee || isInviteeDirector
                ? setCurrentStepJointAccount
                : setCurrentStep
              : Number(applicationType) == 6 ||
                  Number(applicationType) == 7 ||
                  Number(applicationType) == 8
                ? setCurrentStepCorporate
                : setCurrentStepTrust
        }
      />
      {(Number(applicationType) == 1 ||
        Number(applicationType) == 2 ||
        Number(applicationType) == 3 ||
        Number(applicationType) == 4 ||
        Number(applicationType) == 5) &&
        !isInvitee &&
        !isInviteeDirector &&
        !isBusiness &&
        roleName != 'agent' && (
          <div className="flex flex-col lg:flex-row w-full max-w-full mx-auto mt-4 sm:mt-6 gap-4 lg:gap-0 overflow-x-hidden px-2 sm:px-4 lg:px-0">
            <Sidebar
              steps={individualSteps}
              currentStep={currentStep}
              shareholderType={false}
              setCurrentStep={setCurrentStep}
            />
            <main className="w-full lg:w-3/4 flex-1 min-w-0 lg:px-2">
              {renderStepContent()}
            </main>
          </div>
        )}
      {isBusiness && (
        <div className="flex  flex-col lg:flex-row w-full max-w-full mx-auto mt-4 sm:mt-6 gap-4 lg:gap-0 overflow-x-hidden px-2 sm:px-4 lg:px-0">
          <Sidebar
            steps={roleName == 'business' ? stepsBuisness : stepsAgency}
            currentStep={currentStepBusiness}
            shareholderType={false}
            setCurrentStep={setCurrentStepBusiness}
          />
          <main className="w-full lg:w-3/4 flex-1 min-w-0 lg:px-2">
            {renderStepContentBusiness()}
          </main>
        </div>
      )}
      {roleName == 'agent' && (
        <div className="flex flex-col lg:flex-row w-full max-w-full mx-auto mt-4 sm:mt-6 gap-4 lg:gap-0 overflow-x-hidden px-2 sm:px-4 lg:px-0">
          <Sidebar
            steps={stepsAgent}
            currentStep={currentStepAgent}
            shareholderType={false}
            setCurrentStep={setCurrentStepAgent}
          />
          <main className="w-full lg:w-3/4 flex-1 min-w-0 lg:px-2">
            {renderStepContentAgent()}
          </main>
        </div>
      )}
      {(Number(applicationType) == 1 ||
        Number(applicationType) == 2 ||
        Number(applicationType) == 3 ||
        Number(applicationType) == 4 ||
        Number(applicationType) == 5) &&
        (isInvitee || isInviteeDirector) && (
          <div className="flex flex-col lg:flex-row w-full max-w-full mx-auto mt-4 sm:mt-6 gap-4 lg:gap-0 overflow-x-hidden px-2 sm:px-4 lg:px-0">
            <Sidebar
              steps={stepsJointAccount}
              currentStep={currentStepJointAccount}
              shareholderType={false}
              setCurrentStep={setCurrentStepJointAccount}
            />
            <main className="w-full lg:w-3/4 flex-1 min-w-0 lg:px-2">
              {renderStepContentJointAccount()}
            </main>
          </div>
        )}
      {(Number(applicationType) == 6 ||
        Number(applicationType) == 7 ||
        Number(applicationType) == 8) && (
        <div className="flex flex-col lg:flex-row w-full max-w-full mx-auto mt-4 sm:mt-6 gap-4 lg:gap-0 overflow-x-hidden px-2 sm:px-4 lg:px-0">
          <Sidebar
            steps={stepsCorporate}
            currentStep={currentStepCorporate}
            shareholderType={false}
            setCurrentStep={setCurrentStepCorporate}
          />
          <main className="w-full lg:w-3/4 flex-1 min-w-0 lg:px-2">
            {renderStepContentCorporate()}
          </main>
        </div>
      )}
      {(Number(applicationType) == 9 ||
        Number(applicationType) == 10 ||
        Number(applicationType) == 11) && (
        <div className="flex flex-col lg:flex-row w-full max-w-full mx-auto mt-4 sm:mt-6 gap-4 lg:gap-0 overflow-x-hidden px-2 sm:px-4 lg:px-0">
          <Sidebar
            steps={stepsTrust}
            currentStep={currentStepTrust}
            shareholderType={false}
            setCurrentStep={setCurrentStepTrust}
          />
          <main className="w-full lg:w-3/4 flex-1 min-w-0 lg:px-2">
            {renderStepContentTrust()}
          </main>
        </div>
      )}
    </div>
  );
};

export default MultiStepSidebarForm;
